import { IInfOperation, fn } from "@common/utils";
import { constants, Bind, UseOverlay, CreateOverlay } from "@common/navkendo/kutils";
import { INavPageItemControl } from '@common/navkendo/navpageitems';
import { NavKendoRegister } from "@common/navkendo";
import * as angular from 'angular';
import './navadapativepanel'; // referenced indirect via html as widget
/*
 TODO: remove "own" idms_Icon logic ...
 */
const cssIcon = "idms_Icon";
const cssKIcon = "k-icon";
const cssIconTriangleUp = "idms_Icon_Triangle_Up"; // k-icon k-i-arrowhead-n
const cssIconTriangleDown = "idms_Icon_Triangle_Down"; // k-icon k-i-arrowhead-s
const kendoNavDockRef = "kendoNavDockRef";
export const NavDockHoverShow = "NavDockHoverShow";

/** DockZones settings */
export interface INavDockZonesSetting {
  DockZoneWidths: number[];
  DockSettings: INavDockZoneDockSetting[];
}

/** DockZone Docks settings */
export interface INavDockZoneDockSetting {
  ID: string;
  Layout: INavDockLayoutSetting;
}

export interface INavDockZonesOptions extends kendo.ui.SplitterOptions {
  DockOptions: INavDockSetting[];
}

/** Layout settings for Docks */
export interface INavDockLayoutSetting {
  /** Can the Dock be resized? */
  CanResize: boolean;

  /** Is the Dock initially collapsed? */
  IsCollapsed: boolean;

  /** Default height of the Docks content */
  Height: string;

  /** Column index (starting at 0) in which of the DockZones the Dock will be added to */
  DockZone: number;

  /** Row index (starting at 0) the Dock will be positioned in the column of a DockZone */
  Position: number;

  /** Docked/Undocked state */
  DockedOptions?: INavDockedSettings;

  /** Can only resize to max content height (must be fixed!)? */
  MaxContentHeightConstraint?: boolean;

  /** To Discuss : possibility of show DockContent on Hover */
  hoverState?: boolean | IHoverState;
}

/** Settings for the undocked state */
export class INavDockedSettings {
  IsDocked: boolean = true;
  Size = { height: <number>0, width: <number>0 };
  Offset: JQueryCoordinates = <JQueryCoordinates>{ left: -1, top: -1 };
}

export interface IHoverState {
  active: boolean;
}

/** Dock settings */
export interface INavDockSetting {
  /** Can be set by DOM */
  ID?: string;
  Title: string;
  /** angular watched Formula for 'Title' (precedes over explicit Title) */
  TitleFormula?: string;
  /** angular watched Formula for 'TitleInfo' */
  TitleInfoFormula?: string;
  ProgressFormula?: string;
  HtmlContent?: string;
  HtmlContentCss?: string;
  Layout: INavDockLayoutSetting;
  Commands?: string | (Function | IInfOperation)[];
  OnExpansionStateChanged?: () => void;
}

export class NavDockZones extends kendo.ui.Splitter {

  constructor(element: any, options: INavDockZonesOptions) {
    super(element, initPaneOptions());

    // Listen for size changes by layout
    this.bind(constants.NavDestroy, this.element.onSizeChanged(() => {
      kendo.resize(this.element, false);
    }));

    function initPaneOptions() {
      // panes container (collapsible) must be set on base initialization
      (options || (options = <INavDockZonesOptions>{})).panes = $(element).children("div").toArray().map(v => { return <kendo.ui.SplitterPane>{ collapsible: true }; });
      options.orientation = "horizontal";
      return options;
    }

    // Transform each div child to a DockZone
    this.element.children("div").each((index, elem) => {
      var dockZone = $(elem).css("overflow-x", "hidden");

      /** Ignore Actual Content for Drag / Drop Operation
       * (MANST -> PHWO : would expect to revert the logic : only start operation on our header element) */
      var ignore = (idx: number, el: HTMLElement) => $(el).parents(".idms_nodrag").length; // No nesting possible with that!

      // Transform div to sortable DockZone
      var sortable = dockZone.kendoSortable({
        filter: ">div",
        cursor: "move",
        ignore: <any>ignore, // typed as string , but internally (kendo) gets used as prams for JQuery "is" Operator;
        // Is Operator works with function  as defined above also
        connectWith: ".k-pane.k-scrollable",
        hint: this.dndPlaceholder,
        placeholder: this.dndPlaceholder,
        end: e => {
          // Workaround: Refresh Adobe PDF Reader preview to see PDF after dock move
          var movedDock = e.item.data("kendoNavDock");
          movedDock.trigger('DockMoved');
          this.trigger('DockMoved', { Dock: movedDock });

          // Check for single dock on change via Drag&Drop
          this.debouncedUpdateMaximizeSingleDock();
        },
        cursorOffset: { top: -15, left: -15 }
      }).data("kendoSortable");
      this.bind(constants.NavDestroy, fn.proxy(sortable.destroy, sortable));

      // Move descriptive content to content container
      $.each(dockZone.children(), (i, v) => {
        var item = $(v).data("kendoNavDock");
        if (item) {
          item.InitAsDesigned();
        }
      });
      this.debouncedUpdateMaximizeSingleDock();
    });

    // Center splitbar on double click
    $(".k-splitbar", this.element).dblclick(this.SetDefaultSplitPos.bind(this));

    // Add docks from options to dock zones
    const docOptions = options.DockOptions;
    if (docOptions && docOptions.length > 0) {
      docOptions.forEach((value, key) => {
        this.AddDock(value);
      });
    }
  }

  destroy() {
    this.trigger(constants.NavDestroy);

    super.destroy();
  }

  /** Add Dock to DockZone */
  public AddDock(dockOptions: INavDockSetting): NavDock {
    var dockZones = this.GetDockZones(),
      layout = dockOptions && dockOptions.Layout;
    if (layout &&
      layout.DockZone >= 0 &&
      layout.DockZone < dockZones.length) {

      let newDock = $("<div>").kendoNavDock(dockOptions);
      let kdocksOfDockZone = this.GetKendoDocks(layout.DockZone);
      let dockCount = kdocksOfDockZone.length;

      // Insert between existing docks if there are any
      var insertPosFromSetting = layout.Position;
      if (dockCount > 0) {
        // Get position between existing docks
        let finalInsertPos = 0;
        let insertBefore = false;
        let abortLoop = false;

        kdocksOfDockZone.forEach((dock, index) => {
          if (!abortLoop) {
            var currentPos = dock.GetPositionFromSettings();

            // Insert position reached?
            if (currentPos > insertPosFromSetting) {
              finalInsertPos = index;
              insertBefore = true;
              abortLoop = true;
            }
          }
        });

        // Insert pos not found -> Attach to the end
        if (!insertBefore) {
          $(dockZones[layout.DockZone]).append(newDock);
        }
        // Insert pos found -> Prepend to found pos (or append on same position)
        else {
          kdocksOfDockZone[finalInsertPos].element.before(newDock);
        }
      }
      // Just add to DockZone if empty
      else {
        $(dockZones[layout.DockZone]).append(newDock);
      }

      this.debouncedUpdateMaximizeSingleDock();
      let dockWidget = newDock.data("kendoNavDock");

      return dockWidget;
    }
  }

  /** Maximize single dock height (1 dock in 1 column) and normalize non-single dock heights */
  public UpdateMaximizedSingleDock() {
    let dockZones = this.GetDockZones();

    dockZones.each((idx, dockZone) => {
      let docks = this.GetKendoDocks(idx);
      if (docks) {
        let isSingle = docks.length == 1;
        docks.forEach(dock => {
          let currState = dock.GetMaximizeStatus();
          if (isSingle != currState) {
            // Toggle maximized state
            dock.MaximizeHeight(isSingle);
          }
        });
      }
    });
  }
  private debouncedUpdateMaximizeSingleDock = fn.debounce(this.UpdateMaximizedSingleDock, 100);

  /** Get a Dock by its ID */
  public GetDockByID(id: string): NavDock {
    var dock = this.GetDockZones().find("#" + id);
    return dock.length > 0 && dock.data("kendoNavDock");
  }

  /** Apply layout settings to all docks */
  public ApplySettings(settings: INavDockZonesSetting) {
    if (settings) {
      // Apply dockzone widths
      this.ApplySplitterSettings(settings.DockZoneWidths);

      // Apply dock layout settings (IDs for dock elements must be set!)
      if (settings.DockSettings) {
        var kdocks = this.GetKendoDocks();
        if (kdocks && kdocks.length > 0) {
          settings.DockSettings.forEach(ds => {
            // Find dock with setting ID
            var kdock = kdocks.filter(d => d.ID == ds.ID);
            if (kdock && kdock.length > 0) {
              kdock[0].ApplySettings(ds.Layout);
            }
          });
        }
      }
    }
  }

  /** Get a list of the docks layout settings */
  public GetSettings(): INavDockZonesSetting {
    // Docks layout settings
    var layoutSettings = this.GetKendoDocks().map((dock) => {
      return <INavDockZoneDockSetting>{ ID: dock.ID, Layout: dock.GetSettings() };
    });

    // Dockzone widths
    var widths = this.GetKendoDockZones().map(dockZone => dockZone.element.width());
    var total = widths.reduce((sum, width) => sum + width, 0);
    var widthSettings = widths.map(d => parseFloat((d / total).toFixed(2)));

    var settings = <INavDockZonesSetting>{ DockSettings: layoutSettings, DockZoneWidths: widthSettings };
    return settings;
  }

  /** Set the pane size/splitter pos of all DockZones */
  public ApplySplitterSettings(dockZoneWidthInPercent: number[]) {
    if (dockZoneWidthInPercent) {

      // Apply size for each pane
      var dockZones = this.GetDockZones();
      dockZoneWidthInPercent.forEach((value, index) => {
        var currZone = dockZones[index];
        if (!currZone)
          return;

        // Last pane does not need to be set ...
        if (index < dockZones.length - 1) {
          if (value == 0) {
            this.collapse(currZone);
          } else if (value == 1) {
            this.expand(currZone);
          } else {
            var percentStr = (value * 100) + "%";
            this.size(currZone, percentStr);
          }
        }

        // ... unless it is collapsed?
        if (index == dockZones.length - 1 && value == 0)
          this.collapse(currZone);
      });
    }
  }

  /** Get all dockzones of this splitter */
  public GetDockZones(): JQuery {
    return $(this.element).children(".k-pane.k-scrollable");
  }

  /** Get all dockzones of this splitter as Kendo widget */
  public GetKendoDockZones(): kendo.ui.Sortable[] {
    var kDockZones: kendo.ui.Sortable[] = [];
    var dockZones = this.GetDockZones();
    dockZones.each((index, elem) => {
      var kSortable = $(elem).data("kendoSortable");
      if (kSortable)
        kDockZones.push(kSortable);
    });

    return kDockZones;
  }

  /** Get all docks of this splitter or a special dockzone defined as parameter */
  public GetDocks(fromDockZone: number = -1) {
    var dockZones = this.GetDockZones();

    // Only get docks from a special dock zone
    if (fromDockZone >= 0 && fromDockZone < dockZones.length) {
      dockZones = $(dockZones[fromDockZone]);
    } else {
      // Get all docks from all dock zones
    }

    return dockZones.children(".idms_DockWidget");
  }

  /** Get all docks of this splitter or a special dockzone defined as parameter as Kendo widget */
  public GetKendoDocks(fromDockZone: number = -1) {
    return this.GetDocks(fromDockZone).toArray().map(item => $(item).data("kendoNavDock")).filter(fn.isSet);
  }

  /** Drag & Drop insert template */
  private dndPlaceholder(element: JQuery) {
    var dock = <NavDock>element.data("kendoNavDock");
    if (dock) {
      var settings = dock.GetSettings();
      var placeholder = $("<div>").kendoNavDock({ Title: dock.GetTitle(), Layout: { CanResize: false, Height: settings.Height, IsCollapsed: settings.IsCollapsed, DockZone: 0, Position: 0 } });
      placeholder.data("kendoNavDock").destroy();
      return placeholder.css({
        "opacity": 0.5,
        "border": "1px dashed #000000"
      });
    }
    else {
      return element.clone().css({
        "opacity": 0.5,
        "border": "1px dashed #000000"
      });
    }
  }

  /** Set splitbar to the middle */
  private SetDefaultSplitPos(EventObject: JQueryEventObject) {
    if (EventObject) {
      var splitter = $(EventObject.target).closest(".k-splitbar");
      if (splitter.length) {
        var leftPart = splitter.prev();
        var rightPart = splitter.next();
        var centerPos = Math.round((leftPart.width() + rightPart.width()) / 2);

        // See PaneResizing._stop
        leftPart.data("pane").size = centerPos + "px";
        rightPart.data("pane").size = centerPos + "px";

        this.resize(true);
      }
    }
  }
}
NavKendoRegister(<any>NavDockZones, "NavDockZones");

/** Dock of a DockZone */
export class NavDock extends kendo.ui.Widget implements INavPageItemControl {
  /** Get Parent Dock (problem is 'Hover Scenario : element might currently not be child of Dock Element') */
  public static GetParentDock(el: JQuery) {
    let pDock = $(el.parents(":data(kendoNavDock)")[0]).data('kendoNavDock');
    if (!pDock) {
      pDock = $(el.parents(`:data(${kendoNavDockRef}})`)[0]).data(`${kendoNavDockRef}`);
    }
    return pDock;
  }
  public ID: string;
  private readonly content: JQuery;
  /** Optional Parent for detached=hovered content */
  private _detachedContainer?: JQuery;
  private expander: JQuery;
  private titleBar: JQuery;
  protected title: JQuery;
  private titleCounter: JQuery;
  protected titleInfo: JQuery;
  private alertcounter: JQuery;
  public ContentContainer: JQuery;
  public options: INavDockSetting;
  constructor(_element: any, options: INavDockSetting) {
    super(_element, options);

    // Access this object in events
    let me = this,
      element = this.element,
      isFixdesigned = (element.parents().length > 0),
      designedElements = this.element.children();

    // Remember settings from parameter
    options = this.options;
    let layout = options.Layout = options.Layout || <INavDockLayoutSetting>{};

    // Set ID from Options or use it from DOM
    var domID = element.attr("id");
    this.ID = options.ID ? options.ID : domID;
    // Set option ID to DOM if no id in DOM defined
    if (!domID && this.ID) {
      element.attr("id", this.ID);
    }

    // Root dock
    element.addClass("idms_DockWidget");

    // Titlebar
    let titleBar = this.titleBar = $("<div class='idms_WidgetPart idms_DockTitleBar'>");
    // Add title
    this.title = $("<div class='idms_DockTitle'>");
    this.title.text(options.Title);

    titleBar.append(this.title);
    // Add title counter
    this.titleCounter = $("<div class='idms_DockTitleCounter'>");
    titleBar.append(this.titleCounter);
    // Add alert counter
    this.alertcounter = $('<span class="idms_Invalid idms_Text_Alert" style="margin: 0px 0px 0px 10px; padding: 1px 3px; border: 1px solid;"></span>')
      .append('<span class="idms_Icon idms_Icon_Warning idms_Text_Alert" style="margin-right: 5px;"></span>')
      .append('<span class="idms_Text_Alert"></span>');
    this.UpdateAlertCount(0);
    titleBar.append(this.alertcounter);
    // Add commands (expand/collapse, ...)
    var commandBar = $('<div class="idms_DockWidgetCommands"></div>');
    const expander = this.expander = $("<span class='" + cssIcon + " " + cssIconTriangleUp + "' title='Ein-/Ausklappen'></span>");
    commandBar.append(expander);
    // Add commands from parameter
    const parentScope = angular.element($(element)).scope();
    let commands = options.Commands;
    if (typeof commands === "string") {
      const waitCommands = parentScope?.$watch<(Function | IInfOperation)[]>(commands, newValue => {
        if (newValue) {
          waitCommands();
          initCommands(newValue);
        }
      });
    } else if (commands) {
      initCommands(commands);
    }
    function initCommands(this: void, commands: (Function | IInfOperation)[]) {
      if (commands && commands.length > 0) {
        commands.forEach(origValue => {

          if (typeof origValue === "string") {
            // Why only refreshes with String?
            var evaluated = parentScope.$eval(origValue);
            if(evaluated) {
              origValue = evaluated;
            }
            else  {
              const waitCommand = parentScope.$watch(origValue, (newValue: IInfOperation) => {
                if (newValue) {
                  waitCommand();
                  initCommand(newValue);
                }
              });
              return;
            }
          }
          // Default : Check for Operation definition(s) and bind via angular
          initCommand(origValue);
        });
      }

      function initCommand(value: Function | IInfOperation) {
        const injector = <ng.auto.IInjectorService>angular.element($(element)).injector();

        if (injector && parentScope && fn.isOperation(value)) {
          let opValue = value;
          const compile = injector.get("$compile");
          const scope = parentScope.$new();
          scope["Command"] = opValue;
          const useIconClass = opValue && opValue.Icon && opValue.Icon[cssKIcon] ? cssKIcon : cssIcon;
          const lnk = compile("<span class='" + useIconClass + "' inf-operation='Command' ng-class='Command.Icon' style='margin-right: 10px' ng-attr-title='{{Command.Hint}}'></span>");
          expander.before(lnk(scope));
        }
      }
    }
    titleBar.append(commandBar);

    // Add title info
    const titleInfo = this.titleInfo = $("<div class='idms_DockTitleInfo'></div>");
    titleBar.append(titleInfo);

    element.append(titleBar);

    // Add content (resizable bottom)
    this.content = $("<div class='idms_WidgetPart idms_DockRootContainer idms_nodrag'>");
    var contentContainer = this.ContentContainer = $("<div class='idms_DockContentContainer rwfcustomcolor'></div>");
    if (options.HtmlContentCss) { contentContainer.addClass(options.HtmlContentCss); }
    if (options.HtmlContent) { contentContainer.append(options.HtmlContent); }
    this.content.append(contentContainer);

    element.append(this.content);

    if (options.TitleInfoFormula || options.TitleFormula || options.ProgressFormula) {
      let scope = angular.element(element).scope();
      if (scope) {
        if (options.TitleInfoFormula)
          this.bind(constants.NavDestroy, scope.$watch<string>(options.TitleInfoFormula, (newValue) => me.SetTitleInfo(newValue)));
        if (options.TitleFormula)
          this.bind(constants.NavDestroy, scope.$watch<string>(options.TitleFormula, (newValue) => me.SetTitle(newValue || options.Title)));

        if (options.ProgressFormula) {
          const progressInfo = $(`<div class="idms_DockTitleInfo" style="display: none;"><img src="./loading.gif" style="margin: -3px 0px 0px 16px; vertical-align: middle;"></div>`).insertAfter(titleInfo);
          this.bind(constants.NavDestroy, scope.$watch<string>(options.ProgressFormula, (newValue) => progressInfo.toggle(newValue)));
        }
      }
    };

    designedElements.appendTo(contentContainer);
    this.ApplySettings(layout, isFixdesigned);

    this.RegisterEvents();

    this.InitAsDesigned();

    // Dispatch Notification to parent
    this.bind(constants.ExpansionStateChanged, () => {
      const pZone = this.element.closest(':data(kendoNavDockZones)').data('kendoNavDockZones');
      if (pZone)
        pZone.trigger(constants.ExpansionStateChanged, { Dock: this });
    });

    var hState = layout.hoverState;
    if (hState) {
      this.actHover = fn.proxy(initHover, this, typeof hState === "boolean" ? layout.hoverState = { active: true } : hState)();
    }

    this.element.trigger("NavDockCreated", this);

    // Init Hover Functionality
    function initHover(this: NavDock, state: IHoverState) {
      let actHover = {
        SetHover(active?: boolean) {
          if (state.active !== active) {
            setHover(actHover.Checked = state.active = active);
          }
        },
        Execute: () => setHover(actHover.Checked = !actHover.Checked),
        set Checked(c: boolean) { state.active = c; },
        get Checked() { return state.active; },
        Enabled: this.IsCollapsed()
      },
        iconShow = "idms_Icon_Eye",
        iconUnShow = "idms_Icon_EyeSlash",
        btnHover = $(`<span class='idms_Icon ${iconShow}' style='margin-right: 10px' title='automatisches Einblenden de-/aktivieren'></span>`),
        mouseHit = false,
        opCounter = 0,
        barOverlay: any,
        titleBar = this.titleBar,
        title = this.title,
        content = this.content,
        element = this.element,
        postfix = ".docktest",
        shownAbove = false,
        detachedContainer = this._detachedContainer = $("<div class='idms_nodrag' style='position:absolute; background: white; z-index:12'></div>"),
        detachedParent = $("body"),
        watchElements = $().add(detachedContainer).add(titleBar);

      // set reference to Dock available
      detachedContainer.data(kendoNavDockRef, this);
      this.bind(constants.NavDestroy, () => detachedContainer.removeData(kendoNavDockRef));

      commandBar.prepend(btnHover);
      btnHover.click(actHover.Execute);
      // Hide Current on other show
      detachedParent.on(NavDockHoverShow + postfix, () => {
        if (state.active)
          detachedContainer.hide();
      });
      function refresh(newState?: boolean, timeout?: number) {
        if (newState !== undefined)
          mouseHit = newState;

        if (timeout > 0) {
          // Defer if desired
          window.setTimeout(fn.proxy(refresh, null), timeout);
          return;
        }

        if (mouseHit) {
          setContentVisibility(true);
        }
        else if (opCounter <= 0) {
          setContentVisibility(false);
        }
      }

      function setContentVisibility(isVisible: boolean) {
        if (isVisible) {
          const alreadyVisible = detachedContainer.is(":visible");

          if (!alreadyVisible) {
            detachedParent.trigger(NavDockHoverShow);
            if (barOverlay) { barOverlay.Show(); }
          }
          const viewport = $(window),
            pos = titleBar.offset(),
            availHeight = viewport.innerHeight(),
            neededHeight = detachedContainer.outerHeight(),
            remaining = availHeight - (pos.top + title.outerHeight());

          shownAbove = (availHeight > neededHeight) && (remaining < neededHeight);
          if (shownAbove) {
            pos.top -= neededHeight;
          } else {
            pos.top += titleBar.outerHeight();
          }
          detachedContainer.css("top", pos.top).css("left", pos.left).css("width", titleBar.width());

          if (!alreadyVisible) {
            detachedContainer.show();
            me.trigger(NavDockHoverShow);
          }
        } else {
          detachedContainer.hide();
          if (barOverlay) { barOverlay.Hide(); }
        }
      }

      var _contenttAttached = true;
      function attachContent(attach: boolean) {
        if (_contenttAttached == attach)
          return;
        _contenttAttached = attach;
        if (attach) {
          detachedContainer.children().appendTo(me.content);
          detachedContainer.remove();
        } else {
          content.children().appendTo(detachedContainer);
          detachedParent.prepend(detachedContainer);

          if (UseOverlay())
            barOverlay = barOverlay || CreateOverlay(detachedContainer, { Height: 20, Insert: detachedParent, zIndex: -1 });
        }
      }

      function reset() {
        watchElements.off(postfix);
        if (barOverlay) {
          barOverlay.Hide();
        }
      }

      function setHover(hover: boolean) {
        reset();

        if (hover) {
          if (me.IsCollapsed()) {
            attachContent(false);

            refresh($(":hover", watchElements).length > 0); // keep showing if mouse over ...
            var ddOpen = false;
            // Hack : DropDown Open triggers mouse leave, so we have to handle it seperately
            watchElements
              .on("InfDropDownOpen" + postfix, () => ddOpen = true)
              .on("InfDropDownClose" + postfix, () => {
                ddOpen = false;
                if ($(":hover", watchElements).length == 0) {
                  refresh(false, 500);
                }
              })
              .on("mouseenter" + postfix, fn.proxy(refresh, this, true, 80))
              .on("mouseleave" + postfix, (e) => {
                if (!ddOpen)
                  refresh(false, 500);
              });
          }
        } else {
          attachContent(true);
          refresh(true);
        }

        detachedContainer
          .toggleClass(shownAbove ? 'idms_BottomShadow' : 'idms_TopShadow', false)
          .toggleClass(shownAbove ? 'idms_TopShadow' : 'idms_BottomShadow', hover);
        refreshUI();
      }

      function refreshUI() {
        var on = actHover.Checked;
        btnHover.switchClass(on ? iconUnShow : iconShow, on ? iconShow : iconUnShow);
        me.IsCollapsed() ? btnHover.show() : btnHover.hide();
      };

      function notifyOperation(start: boolean) {
        var curr = start ? ++opCounter : --opCounter;
        if (curr == 0 && actHover.Checked)
          window.setTimeout(() => { if (!mouseHit) refresh(); }, 1000);
      }

      this.bind(constants.ExpansionStateChanged, () => {
        if (actHover.Checked)
          setHover(me.IsCollapsed());
        refreshUI();
      });

      let ngJq = angular.element(content);
      let $scope = ngJq.scope();
      if ($scope) {
        // Do not Hide Toolbar during a running Operation
        $scope.$on("InfOperationStart", fn.proxy(notifyOperation, this, true));
        $scope.$on("InfOperationEnd", fn.proxy(notifyOperation, this, false));

        if (state && typeof (state.active) == "boolean") {
          var toSet = state.active;
          delete state.active;
          actHover.SetHover(toSet);
        }
      }

      refreshUI();

      // Cleanup detached Container on element destroy (is outside of own dom)
      this.bind(constants.NavDestroy, () => {
        detachedParent.off(postfix);
        reset();
        kendo.destroy(detachedContainer);
        detachedContainer.remove();
      });
      return actHover;
    }
  }

  private actHover: IInfOperation & { SetHover: (IHoverState: boolean) => void };
  /**
  * Init as Designed Dock Zone.
  * ATTENTION: Loads content twice! Can result in strange behavior with components that are used to load once. */
  public InitAsDesigned() {
    // Remove Children (not part of widget) and reattach to content afterwards
    var children = this.element.children(":not(.idms_WidgetPart)").filter(":not(.ui-resizable-handle)");
    var content = this.element.children(".idms_DockRootContainer");

    // Clear events
    this.RemoveEvents();

    // Do not remove children from Dom, if we do some angular functionality (ng-click etc., will not work anymore)
    //children.remove();

    // Reattach the removed children in the content container
    content.children().append(children);

    // Reattach all events
    this.RegisterEvents();

    // Ensure resizable
    this.ApplyResizable();
  }

  /** Register command bar events */
  public RegisterEvents() {
    // Expand/collapse on double click
    this.titleBar.on("dblclick.nav", () => { this.IsCollapsed() ? this.Expand(false) : this.Collapse(); });

    // ExpandDock
    this.element.on("click.nav", ".idms_DockTitleBar .idms_DockWidgetCommands span." + cssIcon + "." + cssIconTriangleDown, (e) => {
      e.stopImmediatePropagation();
      this.Expand(false);
    })
      // Collapse Dock
      .on("click.nav", ".idms_DockTitleBar .idms_DockWidgetCommands span." + cssIcon + "." + cssIconTriangleUp, (e) => {
        e.stopImmediatePropagation();
        this.Collapse();
      });

    // Focus
    //this.element.on("focusin.nav", evt => {
    //    me.element.addClass("k-state-focused");
    //});
    //this.element.on("focusout.nav", evt => {
    //    me.element.removeClass("k-state-focused");
    //});
  }

  /** Remove all registered events */
  public RemoveEvents() {
    this.element.off(".nav");
    this.titleBar.off(".nav");
  }

  /** Is Dock height defined by content height? */
  public IsAutoHeight() {
    var layout = this.options && this.options.Layout;
    return layout && layout.Height == "auto";
  }
  /** Apply settings to this dock (must be in DOM to apply position) */
  public ApplySettings(settings: INavDockLayoutSetting, setResizable: boolean = true) {
    var layout = this.options && this.options.Layout,
      element = this.element,
      isMoved = layout && settings &&
        (layout.Position != settings.Position || layout.DockZone != settings.DockZone);

    settings = <any>(settings || {});

    // Set resizable? Must be set after descriptive content moved to container in DOM.
    if (setResizable)
      this.ApplyResizable(settings);

    this.ApplyHeight(settings);

    // Set collapsed/expanded
    var isCollapsed = this.IsCollapsed();
    if (settings.IsCollapsed && !isCollapsed) {
      this.Collapse();
    }
    else if (!settings.IsCollapsed && isCollapsed) {
      this.Expand(false);
    }

    // Undock?
    let options = this.options;

    var hState = settings.hoverState;
    if (hState !== undefined && this.actHover) {
      this.actHover.SetHover(typeof hState === "boolean" ? hState : hState.active);
    }
    // Set Position (only if Dock is already in DOM)
    var isInDOM = element.parent().length > 0;
    if (isInDOM) {
      var currentDockZone = this.GetDockZone();
      var splitter = element.closest(".k-splitter");
      var dockZones = splitter.children(".k-pane.k-scrollable");

      if (currentDockZone != settings.DockZone) {
        // Change DockZone
        if (settings.DockZone >= 0 && settings.DockZone < dockZones.length) {
          $(dockZones[settings.DockZone]).append(element);

          // Save new DockZone parent
          options.Layout.DockZone = settings.DockZone;
        }
      }

      var currentPosition = this.GetPosition();
      // Save new position setting
      options.Layout.Position = currentPosition;
      // Update position
      if (currentPosition != settings.Position) {
        var allDocks = element.parent().children(".idms_DockWidget");
        var insertDock = allDocks[Math.min(allDocks.length - 1, Math.max(0, settings.Position))];
        var kReplaceDock = $(insertDock).data("kendoNavDock");

        // Insert dock (but not on same element)
        if (kReplaceDock &&
          this.element[0] != kReplaceDock.element[0]) {
          isMoved = true;
          if (settings.Position < kReplaceDock.GetPosition()) {
            element.insertBefore(insertDock);
          } else {
            element.insertAfter(insertDock);
          }
        }
      }
    }

    // Workaround: Refresh Adobe PDF Reader preview to see PDF after dock move
    if (isMoved) {
      this.trigger('DockMoved');
    }
  }

  private ApplyHeight(settings: INavDockLayoutSetting) {
    if (settings) {
      let isAutoHeight = this.IsAutoHeight();
      if (isAutoHeight) {
        // Force auto height
        settings.Height = "auto";
      } else if (settings.Height && !this._maximizeBehaviorEnabled) {
        // Set height from setting
        this.content.height(settings.Height);
      } else if (!this._maximizeBehaviorEnabled) {
        // Reset maximized height
        this.content.height("auto");
      }
    }
  }

  /** Apply the JQuery UI resizable feature for this dock from the layout settings */
  public ApplyResizable(settings: INavDockLayoutSetting = this.options.Layout) {
    settings = <any>(settings || {});

    // CanResize
    if (settings.CanResize) {
      var me = this;
      var initialMaxHeight = this.content.css("max-height");

      var resizableStartEvent = function (event, ui) {
        // Hide IFrame in content (mouseover will be absorbed otherwise)
        me.hiddenResizeIFrame = me.ContentContainer.find("iframe:visible").first();
        me.hiddenResizeIFrameDisplay = me.hiddenResizeIFrame.css("display");
        me.hiddenResizeIFrame.css("display", "none");

        // Check for max height constraint
        var isMaxContentHeightConstraint = me.options && me.options.Layout && me.options.Layout.MaxContentHeightConstraint;

        // Adapt max resizable height on resizable
        if (isMaxContentHeightConstraint) {
          // Adapt max resizable height to new content height
          var contentHeight = me.ContentContainer.children().outerHeight(true);
          $(this).css("max-height", contentHeight + "px");
          //me.content.resizable(<JQueryUI.ResizableEvents><any><JQueryUI.ResizableOptions | JQueryUI.Resizable>{ maxHeight: maxheight });
        } else {
          // Remove max height constraint
          $(this).css("max-height", initialMaxHeight);
          //me.content.resizable(resizableOptions);
        }
      };

      var resizableStopEvent = function (event, ui) {
        $(this).css("width", '');
        if (me.hiddenResizeIFrame) {
          me.hiddenResizeIFrame.css("display", me.hiddenResizeIFrameDisplay);
        }
        me.onResize();
      };

      var resizableOptions = <JQueryUI.ResizableEvents><any><JQueryUI.ResizableEvents | JQueryUI.Resizable>{
        handles: 's',
        start: resizableStartEvent,
        stop: resizableStopEvent
      };

      this.content.resizable(resizableOptions);
    } else {
      this.RemoveResizable();
    }
  }
  private hiddenResizeIFrame: JQuery = null;
  private hiddenResizeIFrameDisplay: string = "";

  /** Disable the JQuery UI resizable feature for this dock */
  public RemoveResizable() {
    // Undo resizable if active
    if (this.content.hasClass("ui-resizable")) {
      this.content.off("resize.nav");
      this.content.resizable('destroy');
    }
  }

  /** Get the current (not saved) settings of this dock */
  public GetSettings(): INavDockLayoutSetting {
    var settings = this.options,
      layout = settings.Layout,
      isCollapsed = this.IsCollapsed(),
      isAutoHeight = layout.Height == "auto",
      cheight,

      currentHeight = (isCollapsed || isAutoHeight) ?
        layout.Height : ((cheight = this.content.height()) ? cheight + "px" : undefined);

    var hover = layout.hoverState;
    return {
      CanResize: layout.CanResize,
      hoverState: hover ? (typeof hover == "boolean" ? hover : hover.active) : undefined,
      Height: currentHeight,
      IsCollapsed: isCollapsed,
      DockZone: this.GetDockZone(),
      Position: this.GetPosition()
    };
  }

  /** Get the position of this dock defined in its settings. Might differ from real position. */
  public GetPositionFromSettings() {
    return this.options.Layout.Position;
  }

  /** Get the dockzone index the dock is located in */
  public GetDockZone(): number {
    var prevs = this.element.parent().prevAll(".k-pane.k-scrollable");
    return prevs.length;
  }

  /** Get the position/index in the dockzone */
  public GetPosition(): number {
    var prevs = this.element.prevAll(".idms_DockWidget");
    return prevs.length;
  }

  /** Expand the dock content */
  public Expand(scrollIntoView: boolean) {
    // Change action icon
    this.expander.switchClass(cssIconTriangleDown, cssIconTriangleUp);

    // Reset maximized size
    if (this.GetMaximizeStatus() && !this.IsAutoHeight()) {
      let margin = 20; // this.element.outerHeight(true) - this.element.height(); // Problematic calculation, so take static 20px margin
      this.element.height("calc(100% - " + margin + "px)");
    }

    this.content.css("display", "block");
    this.UpdateAdaptivePanels();

    if (this.options.OnExpansionStateChanged) {
      this.options.OnExpansionStateChanged();
    }

    // Scroll dock into view after expand animation
    if (scrollIntoView && this.element.length > 0) {
      this.element[0].scrollIntoView();
    }
    this.trigger(constants.ExpansionStateChanged);
  }

  /** Update all containing adaptive panels */
  private UpdateAdaptivePanels() {
    var adaptivePanels = this.content.find("[data-role='navadaptivepanel']");
    adaptivePanels.each((index, elem) => {
      var ap = $(elem).data("kendoNavAdaptivePanel");
      if (ap) {
        ap.AdaptHeight();
      }
    });
  }

  /** Collapse the dock content */
  public Collapse() {
    this.expander.switchClass(cssIconTriangleUp, cssIconTriangleDown);

    // Reset maximized size
    if (this.GetMaximizeStatus()) {
      this.element.height("auto");
    }

    this.content.css("display", "none");
    if (this.options.OnExpansionStateChanged) {
      this.options.OnExpansionStateChanged();
    }
    this.trigger(constants.ExpansionStateChanged);
  }

  /** Returns the collapsed state */
  public IsCollapsed(): boolean {
    return this.content.css("display") === "none";
  }

  /** Action for the resize event, fired after the end of a vertical resize */
  private onResize() {
    // Update height setting (only for resizable/non-auto-height docks and if not maximized single dock)
    var layout = this.options.Layout,
      isAutoHeight = layout.Height == "auto";
    if (!isAutoHeight && !this._maximizeBehaviorEnabled) {
      layout.Height = this.content.height() + "px";
    }
  }

  /** Get the current title of the dock */
  public GetTitle(): string {
    return this.title.text();
  }

  /** Set the title of the Dock */
  public SetTitle(title: string) {
    this.title.text(title ? title : '');
  }

  /** Set an info text right of the title */
  public SetTitleInfo(info: string) {
    this.titleInfo.text(info ? info : '');
  }

  /** Set the element counter in the title */
  public SetCount(count: number, maxcount?: number, addText?: string) {
    var maxcountText = maxcount >= 0 ?
      '/' + maxcount : '';

    const fullText = count >= 0 ? '(' + count + maxcountText + ')' : '';

    this.titleCounter.text(fullText + (addText && ("   " + addText) || ""));
  }

  // Show amount/sum of Debitor/Kreditor in dock info title
  public SetCountByGrid(grid?: kendo.ui.Grid, addInfo?: string) {
    // Take first grid in content if no grid passed
    if (!grid) {
      var jqgrid = this.content.add(this._detachedContainer).find(".k-grid").first();
      grid = jqgrid.data("kendoGrid") || jqgrid.data("kendoNavGrid");
    }

    if (grid) {
      let ds = grid.dataSource,
        rowCount = ds && ds.data().length,
        filteredRowCount = ds && ds.total(); // "total" is with current filter State

      this.SetCount(filteredRowCount, filteredRowCount != rowCount ? rowCount : undefined, addInfo);
    }
  }

  /** Set the alert count in the dock title (count 0 hides it) */
  public UpdateAlertCount(count: number, title?: string) {
    var alertDisplay = count > 0 ? 'inline' : "none";
    this.alertcounter.attr("title", title ? title : '').css("display", alertDisplay).children("span:last-child").text(count);
  }

  /** Use maximum available height for this dock (only works with Kendo Splitter (NavDockZone) as parent container) */
  public MaximizeHeight(enableBehavior = true) {
    this._maximizeBehaviorEnabled = enableBehavior;

    // ATTENTION:
    // DockZone widget is not initialized at InitAsDesigned time. So get parent splitter by attribute, too (no .k-splitter class set yet).
    // So keep DockZone derivations up to date!
    let parentContainer = this.element.closest("[kendo-nav-pageitem-dock-zones], [kendo-nav-dock-zones], .k-splitter")[0];

    if (parentContainer) {
      let parentContainerHeight = $(parentContainer).height();

      if (enableBehavior && !this.IsAutoHeight()) {
        // Maximize dock height
        let margin = 20; // this.element.outerHeight(true) - this.element.height(); // Problematic calculation, so take static 20px margin
        this.element.height("calc(100% - " + margin + "px)");
        let titleHeight = this.titleBar.outerHeight(true);
        this.content.height("calc(100% - " + titleHeight + "px)");

      } else if (this.options && this.options.Layout) {
        // Undo maximized dock height
        this.element.height("auto");
        this.ApplyHeight(this.options.Layout);
      }

      // Emulate resize event to trigger internal layout adaption on sortable
      this.element.trigger("resize");
    }
  }
  private _maximizeBehaviorEnabled = false;

  /** Get the status of the maximize behavior */
  public GetMaximizeStatus() {
    return this._maximizeBehaviorEnabled;
  }

  /** Propagate Properties (TODO : unify with ViewProperty bases Propagation )*/
  public PropagateProperties(infos: Array<{ Title: string, Value: string }>) {
    infos = infos.filter(item => item && (item.Title || item.Value)).reverse();
    let pItems = fn.ToDictionary(infos, i => i.Title),
      propParent = this.element.find(".idms_DockWidgetCommands"),
      reset = infos.map((info, idx) => {
        let display = $("<span></span>").css("margin-right", "5px");
        display.text((idx < infos.length - 1 ? "| " : "") + (info.Value || " ") + " ");
        display.attr("title", info.Title + ": " + info.Value).toggle(this.IsCollapsed() == true);
        display.prependTo(propParent);
        var x = Bind(this, () => display.toggle(this.IsCollapsed() === true), constants.ExpansionStateChanged);
        return () => {
          x();
          display.remove();
        };
      });

    return () => {
      reset.forEach(r => r());
      reset.length = 0;
    };
  }

  destroy() {
    this.RemoveResizable();
    this.RemoveEvents();
    this.trigger(constants.NavDestroy);
    // DO NOT remove from DOM

    super.destroy();
  }
}
NavKendoRegister(<any>NavDock, "NavDock");

declare global {

  /**  Defined kendo Widgets in this file are automatically available on JQuery ...*/
  interface JQuery {
    /** Multiple DockZones (kendo sortable) divided by splitter */
    kendoNavDockZones(options: INavDockZonesOptions): JQuery;
    data(key: "kendoNavDockZones"): NavDockZones;

    /** Dock/Expander that can be added to a DockZone (sortable panel) */
    kendoNavDock(options: INavDockSetting): JQuery;
    data(key: "kendoNavDock"): NavDock;
  }
}
